export default [
    {
        name: 'domain',
        title: 'Домен',
        filterTitle: 'Домен',
        description: 'Домен',
        sortField: 'domain',
        type: 'string',
        callback: 'domain',
        useInFilter: true,
    },
    {
        name: 'header',
        title: 'Заголовок',
        filterTitle: 'Заголовок',
        description: 'Заголовок',
        sortField: 'header',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'txt',
        title: 'Текст',
        filterTitle: 'Текст',
        description: 'Текст',
        sortField: 'txt',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'links',
        title: 'Ссылки',
        filterTitle: 'Ссылки',
        description: 'Быстрые ссылки',
        sortField: 'links',
        type: 'string',
        callback: 'array',
        useInFilter: true
    },
    {
        name: '__slot:keyscnt_group',
        title: 'Кол-во запросов',
        filterTitle: 'Кол-во запросов',
        description: 'Количество запросов',
        sortField: 'keyscnt',
        dataClass: 'ral',
        type: 'number',
        useInFilter: true,
        isDefault: true
    }
]